<template>
  <v-card
    class="mx-auto"
    flat
    max-width="100%"
    :to="`/meeting/${meetingObj.id}/dashboard/tenant/${tenantId}`"
    :style="`border-left: 20px solid var(--v-primary-base) !important;border-right: 0px solid var(--v-primary-base) !important;`"
    :color="backgroundColor"
  >
    <v-card-text>
      <v-row class="pt-1">
        <v-col cols="12" sm="12" md="5" lg="6" class="pa-1">
          <div class="overline" :style="textColorStyle">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <span v-bind="attrs" v-on="on">
                  <v-icon right left size="20" :dark="isDarkTheme"
                    >mdi-calendar-clock</v-icon
                  >{{ getTimeDetails(meetingObj) }}
                </span>
              </template>
              <span>{{ $t("agenda.lblMeetingSchedule") }}</span>
            </v-tooltip>
          </div>
        </v-col>
        <v-col cols="12" sm="12" md="4" lg="3" class="pa-1">
          <div class="overline" :style="textColorStyle">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <span v-bind="attrs" v-on="on"
                  ><v-icon right left size="20" :dark="isDarkTheme"
                    >mdi-map-marker</v-icon
                  >{{ meetingObj.location }}</span
                >
              </template>
              <span>{{ $t("agenda.lblMeetingLocation") }}</span>
            </v-tooltip>
          </div>
        </v-col>
        <v-col cols="12" sm="12" md="3" lg="3" class="pa-1">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <a-chip
                v-bind="attrs"
                v-on="on"
                class="label-s meetTypeChip"
                label
                outlined
                small
                color="primary"
                >{{ meetingObj.meetingType.label }}</a-chip
              >
            </template>
            <span>{{ $t("agenda.lblMeetingType") }}</span>
          </v-tooltip>
        </v-col>
      </v-row>
      <v-list-item>
        <div
          class="text-h6"
          :style="textColorStyle"
          style="word-break: break-word"
        >
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <h5 v-bind="attrs" v-on="on">
                {{ getMeetingName(meetingObj.meetingName) }}
              </h5>
            </template>
            <span>{{ $t("agenda.lblMeetingTitle") }}</span>
          </v-tooltip>
        </div>
      </v-list-item>

      <v-divider></v-divider>
      <v-list-item>
        <v-list-item-content>
          <div>
            <span v-for="(item, index) in attendees" :key="index" class="mr-1">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-avatar size="25" v-on="on" v-bind="attrs">
                    <v-img
                      v-if="item.profilePhoto"
                      contain
                      :src="item.profilePhoto"
                    ></v-img>
                    <v-img v-else src="@/assets/images/No-Photo.jpg"></v-img>
                  </v-avatar>
                </template>
                <span v-if="item.firstName">{{
                  item.firstName + " " + item.lastName
                }}</span>
                <span v-else> {{ item.email }} </span>
              </v-tooltip>
            </span>
          </div>
        </v-list-item-content>
      </v-list-item>
    </v-card-text>
  </v-card>
</template>
<script>
import { Internationalization } from "@syncfusion/ej2-base";
import customFunctions from "@/codeFiles/taskHelper.js";
import { mapActions, mapState } from "vuex";
export default {
  name: "MeetingCard",
  data() {
    return {
      localUserList: [],
      intl: new Internationalization(),
    };
  },
  props: {
    meetingObj: Object,
  },
  computed: {
    ...mapState({
      userList: (state) => state.people.userList,
    }),
    tenantId() {
      return sessionStorage.getItem("tenantId");
    },
    isDarkTheme() {
      return customFunctions.getContrast(this.backgroundColor);
    },
    backgroundColor() {
      return customFunctions.shadeColor("#EDF0F6", 130);
    },
    textColorStyle() {
      return this.isDarkTheme ? "color:white" : "color:black";
    },
    selectedLang() {
      return this.$i18n.locale;
    },
    attendees() {
      return this.attendeesList.map((item) => {
        const uData = this.updatedUserList.find((u) => u.id == item.id);
        return {
          id: item.id,
          email: item.email,
          attendedState: item.attendedState,
          firstName: uData ? uData.firstName : "",
          lastName: uData ? uData.lastName : "",
          profilePhoto: uData ? uData.profilePhoto : "",
        };
      });
    },
    updatedUserList: {
      get() {
        return this.localUserList;
      },
      set(value) {
        this.localUserList = value;
      },
    },
    attendeesList() {
      return this.meetingObj.attendees;
    },
  },
  async mounted() {
    if (this.userList.length) {
      this.localUserList = _.cloneDeep(this.userList);
      await this.addDeletedUserDetails();
    }
  },
  methods: {
    ...mapActions({
      getDeletedUsersList: "meeting/getDeletedUsersListTemp",
    }),
    addDeletedUserDetails,
    getMeetingName(name) {
      if (name && name.length > 150) {
        return name.slice(0, 150) + "...";
      } else {
        return name;
      }
    },
    shadeColor(color, percentage) {
      return customFunctions.shadeColor(color, percentage);
    },

    getTimeDetails(mDetails) {
      const Xmas95 = new Date(mDetails.scheduletStartTimeInUTC);
      const endDate = new Date(mDetails.scheduledEndTimeInUTC);
      const dateTemp = new Intl.DateTimeFormat(this.selectedLang, {
        dateStyle: "full",
        timeStyle: "long",
      }).format(Xmas95);
      const startDate = new Intl.DateTimeFormat(this.selectedLang, {
        dateStyle: "long",
      }).format(Xmas95);
      const startTime = new Intl.DateTimeFormat(this.selectedLang, {
        timeStyle: "short",
      }).format(Xmas95);
      const endTime = new Intl.DateTimeFormat(this.selectedLang, {
        timeStyle: "short",
      }).format(endDate);
      return `${startDate} (${startTime} - ${endTime})`;
    },
  },
};

async function addDeletedUserDetails() {
  const objectWithIdExists = (id) => this.userList.some((obj) => obj.id === id);

  const unmatchedObjects = this.attendeesList.filter(
    (obj) => !objectWithIdExists(obj.id)
  );
  const unmatchedIds = unmatchedObjects.map((obj) => obj.id);
  if (unmatchedIds.length) {
    const result = await this.getDeletedUsersList(unmatchedIds);
    if (result.length) {
      this.localUserList = this.localUserList.concat(result);
    }
  }
}
</script>
<style scoped>
.meetTypeChip /deep/ .v-chip__content {
  height: fit-content;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: inline-block;
}
::v-deep .v-list-item {
  min-height: 0px !important;
  padding-top: 5px;
}
::v-deep .overline {
  line-height: 1rem !important;
  font-size: 0.75rem !important;
  font-weight: 600 !important;
  letter-spacing: 0.0666666667em !important;
  padding-left: 10px !important;
}
::v-deep .mChip {
  padding: 0 10px;
  margin: 0 20px;
  font-size: 0.85rem !important;
}
::v-deep .v-list-item__content {
  padding: 5px 0 !important;
}
.v-tooltip {
  z-index: 100 !important;
}
</style>